import { NgModule } from "@angular/core";
import { RaskCommonModule } from "../../../common/rask-common.module";
import { ProduktionsomradeDetailDialogService } from "./produktionsomrade-detail/produktionsomrade-detail-dialog.service";
import { ProduktionsomradeDetailComponent } from "./produktionsomrade-detail/produktionsomrade-detail.component";
import { ProduktionsomradeComponent } from "./produktionsomrade.component";
import { ProduktionsomradeService } from "./produktionsomrade.service";

@NgModule({
    imports: [
        RaskCommonModule,
        ProduktionsomradeComponent,
        ProduktionsomradeDetailComponent
    ],
    providers: [
        ProduktionsomradeService,
        ProduktionsomradeDetailDialogService
    ]
})
export class ProduktionsomradeModule { }
